module.exports = __webpack_public_path__ + "static/BHF_Logo_Greyscale_RGB-6adfb9c5a6df385ad6fdc8dedfa026b7.png";